export default __webpack_public_path__ + "static/media/polluted_skyline.78b6d3fa.mp3";